import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor() { }

  /**
   * Gets current Eastern Time timestamp in MMddyyyyHHmmss format
   * @returns string in format MMddyyyyHHmmss (e.g., "102420251759")
   */
  getTimestampByTimeZoneAndLocale(locale: string , timeZone: string): string {
     return new Intl.DateTimeFormat(locale, {
      timeZone: timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).format(new Date());

   }

  /**
   * Converts Eastern Time string to MMddyyyyHHmmss format for filenames
   * @returns string in format MMddyyyyHHmmss (e.g., "102420251545330")
   */
  getFilenameTimestamp(locale: string, timeZone: string): string {
    // Get Eastern Time string: "10/24/2025, 15:45:30"
    const easternTimeString = this.getTimestampByTimeZoneAndLocale(locale, timeZone);
    
    // Convert "10/24/2025, 15:45:30" to "102420251545330"
    const datePart = easternTimeString.split(', ')[0]; // "10/24/2025"
    const timePart = easternTimeString.split(', ')[1]; // "15:45:30"
    
    const [month, day, year] = datePart.split('/');
    const [hour, minute, second] = timePart.split(':');
    
    return `${month}${day}${year}${hour}${minute}${second}`;
  }

}